import {
  AfterViewInit,
  Component,
  ComponentRef,
  Input,
  OnDestroy,
  Type,
  ViewChild,
  ViewContainerRef,
  computed,
  effect,
  input,
} from '@angular/core';
import { convertToGalaxyFilterValues } from '@galaxy/crm/static';
import { FilterValueInterface } from '@vendasta/crm';
import { GalaxyAbstractFilterChip } from '@vendasta/galaxy/filter/chips';

@Component({
  selector: 'crm-scoring-definition-custom-filter-output',
  template: ` <ng-template #viewContainerRef></ng-template> `,
})
export class ScoringDefinitionCustomFilterOutputComponent implements AfterViewInit, OnDestroy {
  @Input({ required: true }) filterChip!: Type<GalaxyAbstractFilterChip>;
  initialValue = input<FilterValueInterface[] | undefined>(undefined);

  @ViewChild('viewContainerRef', { static: false, read: ViewContainerRef }) viewContainerRef!: ViewContainerRef;

  private componentRef: ComponentRef<GalaxyAbstractFilterChip> | null = null;
  private glxyValue = computed(() => convertToGalaxyFilterValues(this.initialValue() ?? []));

  constructor() {
    effect(() => {
      const v = this.glxyValue();
      if (this.componentRef) {
        this.componentRef.instance.initialValue = v;
      }
    });
  }

  ngAfterViewInit(): void {
    this.viewContainerRef.clear();
    this.componentRef = this.viewContainerRef.createComponent<GalaxyAbstractFilterChip>(this.filterChip);
  }

  ngOnDestroy(): void {
    this.componentRef?.destroy();
    this.componentRef = null;
  }
}
